import { useState } from "react";
import {
  type DetailsForm,
  DraftDetailsDialog,
  EMPTY_DETAILS,
  deadlineAllowed,
  isComplete,
} from "./DraftDetailsFields";
import { useStartDraft } from "../layout/start-draft";

/**
 * Starts a patent draft under a client with the four details it is made with:
 * the invention name, its inventors, where it is filed and by when. Create
 * Draft stays closed until all four are given; the draft then opens at Intake.
 */
export function NewDraftDialog({
  clientId,
  open,
  onClose,
}: {
  clientId: string;
  open: boolean;
  onClose: () => void;
}) {
  const [form, setForm] = useState<DetailsForm>(EMPTY_DETAILS);
  const { start, starting } = useStartDraft();

  function close() {
    setForm(EMPTY_DETAILS);
    onClose();
  }

  return (
    <DraftDetailsDialog
      open={open}
      title="Start a new patent draft"
      description="These details set up the file. You can edit them later."
      form={form}
      onChange={(change) => {
        setForm((was) => ({ ...was, ...change }));
      }}
      clientId={clientId}
      submitLabel={starting ? "Creating…" : "Create Draft"}
      ready={isComplete(form) && deadlineAllowed(form.deadline) && !starting}
      onSubmit={() => {
        start(clientId, {
          title: form.title.trim(),
          inventors: form.inventors.map((inventor) => inventor.name),
          jurisdiction: form.jurisdiction,
          filing_deadline: form.deadline,
        }).then(close, () => {
          // The toast has said it failed; the dialog stays open with what was typed.
        });
      }}
      onClose={close}
    />
  );
}
